<template>
    <div class="loader-wrapp">
        <div class="loaderr">
            <i class="fa fa-3x fa-spinner fa-spin"></i>
        </div>
    </div>
</template>
